import { useFeatureIsOn } from '@growthbook/growthbook-react'

import type { Layout, Model, ModelsDataType } from '../Recommendations'
import { Recommendations } from '../Recommendations'

export type CandidatesType = {
  control: Model
  variant: Model
}

interface MultiModelsRecommendedForYouProps {
  models: ModelsDataType
  whichId: string
  layout: Layout
  candidates: CandidatesType
  position?: string
}

export const MultiModelsRecommendedForYou = ({
  models,
  whichId,
  layout,
  candidates,
  position,
}: MultiModelsRecommendedForYouProps) => {
  const showComponent = useFeatureIsOn('r4u-new-model-comparison')

  if (showComponent) {
    return (
      <Recommendations
        model={models[candidates.variant]}
        whichId={whichId}
        layout={layout}
        position={position}
      />
    )
  }

  return (
    <Recommendations
      model={models[candidates.control]}
      whichId={whichId}
      layout={layout}
      position={position}
    />
  )
}
